import styled, { css } from 'styled-components'
import { media } from 'shared-ui/utils/media'
export const ProfileContainer = styled.div`
  min-height: 100vh;
  color: ${({ theme }) => theme.app.text};
  background: ${({ theme }) => theme.app.background};
  padding-left: ${({ isMobile }) => (isMobile ? '20px' : '5rem')};
  padding-right: ${({ isMobile }) => (isMobile ? '20px' : '5rem')};
`

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding-top: 20px;
  background: ${({ theme }) => theme.app.background};
  border-bottom-left-radius: 32px;
  border-bottom-right-radius: 32px;
  position: relative;
`

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
`

export const EditProfile = styled.div`
  color: #00bfff;
  font-size: 12px;
  cursor: pointer;
  font-weight: 600;
  margin-bottom: 8px;
  cursor: pointer;
`

export const Avatar = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  // border: 3px solid ${({ theme }) => theme.app.text};
  object-fit: cover;
  margin-left: 18px;
  margin-top: 2px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  background-color: ${({ theme }) => theme.app.upload};
`

export const AvatarCreator = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.app.settingCardBg};
  object-fit: cover;
  margin-top: 2px;
  margin-left: 18px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
`

export const UserName = styled.div`
  font-size: 28px;
  font-weight: 900;
  margin-bottom: 2px;
  font-style: Bold;
  color: ${({ theme }) => theme.app.text};
  text-align: left;
`

export const Bio = styled.div`
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  vertical-align: middle;
  color: ${({ theme }) => theme.app.iconlabel};
  text-align: left;
  margin-bottom: 10px;
  max-width: 220px;
`

export const Divider = styled.div`
  width: 92vw;
  height: 1.5px;
  background: #232323;
  margin: 16px;
`

export const StatsRow = styled.div`
  // display: flex;
  // justify-content: flex-start;
  // align-items: center;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  // padding: 0 16px 0 16px;
  margin-bottom: 0;
`

export const StatsCreatorRow = styled.div`
  // display: flex;
  // justify-content: flex-start;
  // align-items: center;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  margin-bottom: 0;
  margin-top: 6px;
`

export const StatBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
`

export const StatValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.app.text};
`

export const StatLabel = styled.div`
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  color: ${({ theme }) => theme.app.iconlabel};
`

export const PlanCreditsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  margin-top: 10px;
  background: ${({ theme }) => theme.app.upload};
  padding: 16px;
  // margin-left: 16px;
  // margin-right: 16px;
  border-radius: 16px;
`

export const PlanBox = styled.div`
  background: transparent;
  border-radius: 14px;
  padding: 0;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: start;
  color: ${({ theme }) => theme.app.text};
  width: max-content;
  .upgrade {
    color: #00bfff;
    font-size: 12px;
    cursor: pointer;
    font-weight: 700;
    text-decoration: none;
  }
`

export const CreditsBox = styled.div`
  background: transparent;
  border-radius: 14px;
  padding: 0;
  font-size: 15px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: start;
  color: ${({ theme }) => theme.app.text};
  .get-credits {
    color: #00bfff;
    font-size: 12px;
    cursor: pointer;
    font-weight: 700;
    text-decoration: none;
  }
`

export const LatestCreationsSection = styled.div`
  margin-top: 24px;
  padding: 0 8px;
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  h3 {
    font-size: 21px;
    font-weight: 900;
    margin: 0;
    letter-spacing: 0.2px;
  }
`

export const DashboardLink = styled.div`
  color: #00bfff;
  font-size: 15px;
  cursor: pointer;
  font-weight: 700;
  text-decoration: underline;
`

export const Tabs = styled.div`
  display: flex;
  margin: 18px 0 12px 0;
  background: ${({ theme }) => theme.app.background};
  border-radius: 28px;
  overflow: hidden;
  border: 2px solid #00bfff;
`
export const TabButton = styled.button`
  flex: 1;
  padding: 12px 0;
  background: ${({ theme }) => theme.app.background};
  color: ${({ theme }) => theme.app.text};
  font-size: 17px;
  font-weight: 700;
  border: none;
  outline: none;
  cursor: pointer;
  transition:
    background 0.2s,
    color 0.2s;
  &:first-child {
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
  }
  &:last-child {
    border-top-right-radius: 24px;
    border-bottom-right-radius: 24px;
  }
  position: relative;

  &:not(:first-child) {
    padding-left: 8px;
  }

  &:not(:first-child)::before {
    content: '';
    position: absolute;
    left: -1px;
    top: 1px;
    bottom: 1px;
    width: 1px;
    background: #00bfff;
    border-radius: 1px;
    pointer-events: none;
    z-index: 9999;
  }
  ${({ active }) =>
    active
      ? css`
          background: #00bfff;
          color: ${({ theme }) => theme.app.text};
        `
      : css`
          background: ${({ theme }) => theme.app.background};
          color: ${({ theme }) => theme.app.text};
        `}
`

export const CreationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const CreationCard = styled.div`
  background: #181818;
  border-radius: 18px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
`

export const CreationImage = styled.img`
  width: 100%;
  aspect-ratio: 1/1;
  object-fit: cover;
`

export const CreationTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.app.text};
  position: absolute;
  left: 10px;
  bottom: 10px;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.7);
  z-index: 2;
`

export const PlayIcon = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 26px;
  height: 26px;
  background: url('data:image/svg+xml;utf8,<svg fill="white" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="rgba(0,0,0,0.5)"/><polygon points="10,8 16,12 10,16" fill="white"/></svg>')
    no-repeat center center;
  background-size: contain;
  z-index: 2;
`

export const FollowedByText = styled.div`
  display: flex;
  margin-top: 10px;
  text-align: left;
`

export const EditProfileContainer = styled.div(
  ({ theme, isModal, isMobile, isTablet }) => ({
    minHeight: '100vh',
    width: isModal ? 'auto' : '',
    display: 'flex',
    flexDirection: 'column',
    alignItems: isMobile ? 'center' : 'start',
    paddingRight: isModal ? '1vw' : '',
    paddingTop: isModal ? '0' : '',
    paddingLeft: isMobile ? '0' : isTablet ? '' : '80px',
    background: theme.app.background,
    margin: isMobile && '16px',
    marginTop: !isMobile && '48px'
  })
)

export const EditProfileTopBar = styled.div(({ isMobile }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center'
}))

export const EditProfileBackBtn = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.app.text};
  // margin-left: 16px;
  cursor: pointer;
`

export const EditProfileTitle = styled.div(({ theme, isMobile }) => ({
  flex: 1,
  textAlign: 'left',
  fontSize: isMobile ? '16px' : '28px',
  fontWeight: isMobile ? '400' : '700',
  marginLeft: isMobile ? '16px' : '25px',
  color: theme.app.text
}))

export const EditProfileAvatarWrapper = styled.div(({ isMobile, theme }) => ({
  display: isMobile ? 'flex' : 'grid',
  gridTemplateColumns: '1fr 2fr',
  flexDirection: isMobile ? 'column' : 'row',
  alignItems: isMobile ? 'center' : 'center',
  margin: isMobile?'24px 0px':'24px 24px',
  width: '100%',
  maxWidth: isMobile ? '400px' : '508px',
  border: isMobile ? 'none' : `1px solid ${theme.app.inputBorder}`,
  borderRadius: isMobile ? '0' : '4px',
  padding: isMobile ? '0' : '16px'
}))

export const EditProfileSubContainer = styled.div`
    margin: 24px 24px;
    display: ${({ isMobile }) => isMobile ? 'grid' : 'flex'};
`

export const EditProfilNotifyWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid  #182230;
    padding: 12px 0;
`

export const EditProfileNotifyText = styled.div`
    font-size: 13.5px;
    color: #98A2B3;
    font-weight: 400;
`
export const NotifyContent = styled.div`
    display: flex;
    text-align: left;
    font-size: 11.5px;
    color: #98A2B3;
    font-weight: 400;
    `

export const EditProfileAvatarButton = styled.button`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: none;
  background: #222;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  cursor: pointer;
  margin-bottom: 8px;
`

export const EditProfileAvatarImg = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`

export const EditProfileChangePicText = styled.div`
  color: ${({ theme }) => theme.app.eternalDescription};
  font-size: 13px;
  margin-top: 8px;
  // margin-bottom: 32px;
`

export const EditProfileAvatarOptions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: space-between;
  margin-top: 8px;
`

export const EditProfileAvatarOption = styled.button`
  background: none;
  border: none;
  color: #00bfff;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 0;
  text-align: left;

  &:hover {
    color: #0099cc;
  }
`

export const EditProfileAvatarIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const EditProfileForm = styled.form(({ isMobile }) => ({
  // width: '100%',
  maxWidth: isMobile ? '400px' : '',
  borderRadius: '18px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: isMobile ? 'center' : 'flex-start',
  gap: '32px',
  margin: isMobile ? '0 auto' : '0 24px',
  padding: '24px 0'
}))

export const EditProfileField = styled.div`
  width: 312px;
  display: flex;
  flex-direction: column;
`

export const EditProfileRow = styled.div`
  display: flex;
  gap: 12px;
  width: 312px;
`

export const EditProfileDateFieldWrapper = styled.div`
  position: relative;
  width: 334px;
`

export const EditProfileTrailingIcon = styled.img`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  pointer-events: none;
`

export const EditProfileSaveButtonWrapper = styled.div`
  margin-top: 0;
  display: flex;
  justify-content: center;
`

export const EditProfileSelect = styled.select`
  width: 100%;
  height: 44px;
  padding: 10px;
  border-radius: 5px;
  background: transparent;
  color: ${({ theme }) => theme.app.text};
  border: 1px solid ${({ theme }) => theme.app.border};
  font-size: 14px;
  outline: none;
  appearance: none;
  transition: border 0.2s;
  &:focus {
    border: 2px solid ${({ theme }) => theme.app.accent};
    color: ${({ theme }) => theme.app.text};
  }
`

export const EditProfileTextarea = styled.textarea`
  width: 100%;
  height: 90px;
  padding: 10px;
  border-radius: 5px;
  background: transparent;
  color: ${({ theme }) => theme.app.border};
  border: 1px solid ${({ theme }) => theme.app.border};
  font-size: 14px;
  outline: none;
  resize: none;
  transition: border 0.2s;
  &:focus {
    border: 2px solid ${({ theme }) => theme.app.accent};
    color: ${({ theme }) => theme.app.text};
  }
`

export const EditProfileButton = styled.button`
  width: 100%;
  height: 44px;
  background: #05485e;
  color: ${({ theme }) => theme.app.text};
  font-size: 16px;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  margin-top: 8px;
  transition: background 0.2s;
  &:hover {
    background: #03607a;
  }
`

export const MoreSheetOption = styled.div`
  display: flex;
  align-items: center;
  padding: 18px 0px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`

export const MoreSheetIcon = styled.img`
  width: 22px;
  height: 22px;
  margin-right: 16px;
`

export const ReportSheetContainer = styled.div`
  padding: 0px 16px 18px 16px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 100%;
  box-sizing: border-box;
`

export const ReportTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: ${({ theme }) => theme.app.text};
  margin: 0;
  text-align: left;
`

export const ReportNote = styled.div`
  color: #999999;
  font-size: 14px;
  margin: 6px 0 22px 0;
  text-align: left;
  line-height: 1.45;
`

export const ReportFieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 22px;
`

export const ReportLabel = styled.div`
  color: ${({ theme }) => theme.app.text};
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 8px;
`

export const AboutAccountSheet = styled.div`
  padding: 0;
  color: ${({ theme }) => theme.app.text};
`

export const AboutAccountTitle = styled.div`
  text-align: left;
  font-size: 22px;
  font-weight: 400;
  margin-bottom: 24px;
  letter-spacing: 0%;
  color: ${({ theme }) => theme.app.iconlabel};
`

export const AboutAccountDetails = styled.div`
  padding: 10px 22px 22px 22px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: ${({ theme }) => theme.app.settingCardBg};
  border-radius: 16px;
`

export const AboutAccountRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  color: #b3b3b3;
`
export const CreatorBackBtn = styled.div`
  border: 'none';
  background: 'none';
  cursor: 'pointer';
`

export const MoreOptionBtn = styled.button`
  background: 'none';
  border: 'none';
  cursor: 'pointer';
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
`

export const DesktopProfileSection = styled.div`
  width: 100%;
  padding: 3rem 0px 24px 0px;
  position: relative;
`

export const ProfileHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`

export const ProfileContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 24px;
`

export const ProfileAvatar = styled.img`
  width: 160px;
  height: 160px;
  border-radius: 50%;
  border: 3px solid white;
  object-fit: cover;
  flex-shrink: 0;
`

export const ProfileInfo = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-left: 2%;
  width: 100%;
`

export const ProfileUsername = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: ${(props) => props.theme.app.text};
`

export const ProfileBio = styled.div`
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  vertical-align: middle;
  max-width: 768px;
  color: #cccccc;
`

export const EditProfileLink = styled.div`
  color: #12c2ff;
  font-size: 14px;
  cursor: pointer;
  width: fit-content;
`

export const StatItem = styled.div`
  cursor: ${(props) => (props.clickable ? 'pointer' : 'not-allowed')};
`

export const StatNumber = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => props.theme.app.text};
`

export const StatText = styled.div`
  font-weight: 400;
  font-style: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  color: ${(props) => props.theme.app.iconlabel};
`

export const FollowedBySection = styled.div`
  margin-top: 10px;
`

export const RightActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  position: relative;
`

export const MoreButton = styled.button`
  padding: 8px;
  border-radius: 50%;
  border: 1px solid #12c2ff33;
  background: none;
  color: ${(props) => props.theme.app.text};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`

export const DropdownMenu = styled.div`
  position: absolute;
  z-index: 1;
  right: 0;
  top: 100%;
  margin-top: 24px;
  background: ${(props) => props.theme.app.background};
  border: 1px solid #313131;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.5);
  padding: 8px 0;
`

export const DropdownContent = styled.div`
  min-width: 215px;
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const DropdownOption = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 16px;
  text-align: left;
  background: none;
  border: none;
  cursor: pointer;
  width: 100%;
  transition: background-color 0.2s;
  font-weight: 500;

  &:hover {
    background: ${({ theme }) => theme.app.settingCardBg};
  }
`

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 15px;
  margin-bottom: 8px;
  // padding: 0 40px;
`

export const PanelOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${(props) => props.zIndex || 50};
`

export const PanelBackground = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.55);
`

export const PanelContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 420px;
  max-width: 90vw;
  background: ${(props) => props.theme.app.background};
  border-left: 1px solid #222;
  z-index: ${(props) => props.zIndex || 1001};
`

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) => props.padding || '16px 20px'};
  border-bottom: 1px solid #222;
  margin-left: 27px;
`

export const CloseButton = styled.button`
  padding: 4px;
  border-radius: 4px;
  background: none;
  border: none;
  color: ${({ theme }) => theme.app.text};
  cursor: pointer;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
`
export const PromoLogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;
  text-align: center;
  color: ${({ theme }) => theme.app.text};
  @media ${media.desktop || media.tablet || media.tabletLandscape} {
    width: 379px;
    height: auto;
    border: 1px solid ${({ theme }) => theme.app.border};
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    min-height: auto;
    position: absolute;
    display: grid;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
    padding: 20px;
  }

  ${({ isLandscape, theme }) =>
    isLandscape &&
    ` 
    width: 379px;
    height: auto;
    border: 1px solid ${theme.app.border};
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    min-height: auto;
    position: unset;
    display: grid;
    transform: translate(-3%, 11%);
    top: 50%;
    left: 50%;
    padding: 20px;
  `}
`
export const PromoScreenBottomContainer = styled.div`
  position: ${({ isLandscape }) => (isLandscape ? 'unset' : 'absolute')};
  width: 100%;
  bottom: 120px;
  // margin-bottom: 32px;
  text-align: center;
  @media ${media.desktop || media.tablet || media.tabletLandscape} {
    position: relative;
    left: 0;
    bottom: 0;
    margin-top: 20px;
  }
`
export const PromoSplashImage = styled.img`
  position: absolute;
  top: 0;
  height: 32px;
  object-fit: cover;
  z-index: 2;
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 24px 0 32px 0;
`

export const RadioCircle = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #bdbdbd;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  box-sizing: border-box;
  position: relative;

  ${(props) =>
    props.selected &&
    `
      border: 2px solid #00bfff;
      &::after {
        content: '';
        display: block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #00bfff;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    `}
`

export const MobileOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: ${({ theme }) => theme.app.background};
  z-index: 1050;
  display: flex;
  flex-direction: column;
`

export const MobileHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  position: relative;
`

export const MobileBackButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.app.text};
`

export const MobileContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 40px 50px;
  min-height: 0;
  position: relative;
  text-align: center;
`

export const MobileTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 24px;
  color: ${({ theme }) => theme.app.text};
`

export const MobileContentCenter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  width: 100%;
  gap: 24px;
`

export const MobileDescription = styled.div`
  text-align: left;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.app.iconlabel};
  width: 100%;
  text-align: center;
  font-weight: 400;
`

export const MobileInputWrapper = styled.div`
  width: 100%;
`

export const MobileButtonWrapper = styled.div`
  width: 100%;
  max-width: 312px;
  display: flex;
  justify-content: center;
  margin-top: 36px;
`

export const BlockedUserWrapper = styled.div`
  max-width: ${({ isMobile }) => (isMobile ? '310px' : '630px')};
`

export const BlockedUserTitle = styled.div`
  color: ${({ theme }) => theme.app.text};
  font-size: 20px;
  font-weight: 600;
`

export const BlockedUserDescription = styled.div`
  color: ${({ theme }) => theme.app.iconlabel};
  font-size: 14px;
`
export const WarningTextWrapper = styled.div`
  background: #ffffff1f;
  font-size: 14px;
  padding: 12px 16px;
  border-radius: 14px;
  display: flex;
  align-items: center;
`
export const WarningText = styled.div`
  font-size: 14px;
  font-weight: 400;
  margin-left: 4px;
  color: ${({ theme }) => theme.app.iconlabel};
`